import React from "react"
import PageHeader from "../../../../components/Elements/PageHeader"
import { QuestionCircleOutlined, UserAddOutlined, UsergroupAddOutlined } from "@ant-design/icons"
import { Card, Col, Row, Space } from "antd"
import CreateClientPopup from "../../../../components/Clients/CreateClientPopup"
import CreateClientGroupPopup from "../../../../components/Clients/CreateClientGroupPopup"
import CreateLeadPopup from "../../../../components/Clients/CreateLeadPopup"

export default function CreateClientManager() {
  return (
    <div className="page-padding">
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <PageHeader text="Create Client" icon={<UserAddOutlined />} />
        </Col>
        <Col span={12}>
          <Card
            className="create-card"
            title="Create Client"
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}>
            <Space direction="vertical" align="center">
              <UserAddOutlined style={{ fontSize: "80px" }} />
              <CreateClientPopup />
            </Space>
          </Card>
        </Col>
        <Col span={12}>
          <Card
            className="create-card"
            title="Create Group"
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}>
            <Space block direction="vertical" align="center">
              <UsergroupAddOutlined style={{ fontSize: "80px" }} />
              <CreateClientGroupPopup />
            </Space>
          </Card>
        </Col>
        <Col span={12}>
          <Card
            className="create-card"
            title="New Lead"
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}>
            <Space block direction="vertical" align="center">
              <QuestionCircleOutlined style={{ fontSize: "80px" }} />
              <CreateLeadPopup />
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  )
}
